import { jsx, jsxs } from 'react/jsx-runtime';
import { getTextColor } from '@fabric-app/utils/color';

const CursorNormal = ({ color, ...props }) => {
  const outlineColor = getTextColor(color);
  return /* @__PURE__ */ jsx("svg", {
    width: "52",
    height: "53",
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsxs("g", {
      children: [
        /* @__PURE__ */ jsx("path", {
          d: "M13.935 8.623 20.969 47.2l8.904-14.669 16.965-2.577L13.935 8.623Z",
          fill: color
        }),
        /* @__PURE__ */ jsx("path", {
          d: "M13.935 8.623 20.969 47.2l8.904-14.669 16.965-2.577L13.935 8.623Z",
          stroke: outlineColor,
          strokeWidth: "3"
        })
      ]
    })
  });
};

export { CursorNormal as default };
//# sourceMappingURL=CursorNormal.js.map
